export default {
    data () {
        return {
        
            
        }
    },
    methods: {
        mouseoverTooltip (row, e) {
            if (e.target.scrollWidth > e.target.clientWidth) {
                this.$set(row, 'tooltip_disabled', false)
            } else {
                this.$set(row, 'tooltip_disabled', true)
            }
        },
    }
}